
import { useState, useEffect } from 'react';
import { cn } from '@/lib/utils';
import NavbarContent from './navbar/NavbarContent';
import { useIsMobile } from '@/hooks/use-mobile';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const isMobile = useIsMobile();
  
  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header 
      className={cn(
        "fixed top-0 left-0 right-0 z-50 transition-all duration-300 px-3 md:px-6",
        scrolled 
          ? "py-2 bg-white/90 backdrop-blur-lg border-b border-border/40 shadow-sm" 
          : isMobile ? "py-3 bg-transparent" : "py-4 bg-transparent"
      )}
    >
      <NavbarContent />
    </header>
  );
};

export default Navbar;
